/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyShipmentQuote } from "./CompanyShipmentQuote";
import {
  CompanyShipmentQuoteFromJSON,
  CompanyShipmentQuoteFromJSONTyped,
  CompanyShipmentQuoteToJSON,
  CompanyShipmentQuoteToJSONTyped,
} from "./CompanyShipmentQuote";
import type { CompanyShipment } from "./CompanyShipment";
import {
  CompanyShipmentFromJSON,
  CompanyShipmentFromJSONTyped,
  CompanyShipmentToJSON,
  CompanyShipmentToJSONTyped,
} from "./CompanyShipment";

/**
 *
 * @export
 * @interface ActiveShipments
 */
export interface ActiveShipments {
  /**
   *
   * @type {Array<CompanyShipment>}
   * @memberof ActiveShipments
   */
  manuallyQuoting: Array<CompanyShipment>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  unfinishedBooking: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  onHold: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  pickingUpSoon: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  pickupToday: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  pickupIsLate: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  inTransit: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  delivered: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  pickupDeadLines: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  deliveryDeadLines: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  pendingCustomsClearance: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  freightDamaged: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  operatorFlagged: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  customerFlagged: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof ActiveShipments
   */
  freightShortage: Array<CompanyShipmentQuote>;
}

/**
 * Check if a given object implements the ActiveShipments interface.
 */
export function instanceOfActiveShipments(
  value: object,
): value is ActiveShipments {
  if (!("manuallyQuoting" in value) || value["manuallyQuoting"] === undefined)
    return false;
  if (
    !("unfinishedBooking" in value) ||
    value["unfinishedBooking"] === undefined
  )
    return false;
  if (!("onHold" in value) || value["onHold"] === undefined) return false;
  if (!("pickingUpSoon" in value) || value["pickingUpSoon"] === undefined)
    return false;
  if (!("pickupToday" in value) || value["pickupToday"] === undefined)
    return false;
  if (!("pickupIsLate" in value) || value["pickupIsLate"] === undefined)
    return false;
  if (!("inTransit" in value) || value["inTransit"] === undefined) return false;
  if (!("delivered" in value) || value["delivered"] === undefined) return false;
  if (!("pickupDeadLines" in value) || value["pickupDeadLines"] === undefined)
    return false;
  if (
    !("deliveryDeadLines" in value) ||
    value["deliveryDeadLines"] === undefined
  )
    return false;
  if (
    !("pendingCustomsClearance" in value) ||
    value["pendingCustomsClearance"] === undefined
  )
    return false;
  if (!("freightDamaged" in value) || value["freightDamaged"] === undefined)
    return false;
  if (!("operatorFlagged" in value) || value["operatorFlagged"] === undefined)
    return false;
  if (!("customerFlagged" in value) || value["customerFlagged"] === undefined)
    return false;
  if (!("freightShortage" in value) || value["freightShortage"] === undefined)
    return false;
  return true;
}

export function ActiveShipmentsFromJSON(json: any): ActiveShipments {
  return ActiveShipmentsFromJSONTyped(json, false);
}

export function ActiveShipmentsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActiveShipments {
  if (json == null) {
    return json;
  }
  return {
    manuallyQuoting: (json["manuallyQuoting"] as Array<any>).map(
      CompanyShipmentFromJSON,
    ),
    unfinishedBooking: (json["unfinishedBooking"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    onHold: (json["onHold"] as Array<any>).map(CompanyShipmentQuoteFromJSON),
    pickingUpSoon: (json["pickingUpSoon"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    pickupToday: (json["pickupToday"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    pickupIsLate: (json["pickupIsLate"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    inTransit: (json["inTransit"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    delivered: (json["delivered"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    pickupDeadLines: (json["pickupDeadLines"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    deliveryDeadLines: (json["deliveryDeadLines"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    pendingCustomsClearance: (
      json["pendingCustomsClearance"] as Array<any>
    ).map(CompanyShipmentQuoteFromJSON),
    freightDamaged: (json["freightDamaged"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    operatorFlagged: (json["operatorFlagged"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    customerFlagged: (json["customerFlagged"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
    freightShortage: (json["freightShortage"] as Array<any>).map(
      CompanyShipmentQuoteFromJSON,
    ),
  };
}

export function ActiveShipmentsToJSON(json: any): ActiveShipments {
  return ActiveShipmentsToJSONTyped(json, false);
}

export function ActiveShipmentsToJSONTyped(
  value?: ActiveShipments | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    manuallyQuoting: (value["manuallyQuoting"] as Array<any>).map(
      CompanyShipmentToJSON,
    ),
    unfinishedBooking: (value["unfinishedBooking"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    onHold: (value["onHold"] as Array<any>).map(CompanyShipmentQuoteToJSON),
    pickingUpSoon: (value["pickingUpSoon"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    pickupToday: (value["pickupToday"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    pickupIsLate: (value["pickupIsLate"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    inTransit: (value["inTransit"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    delivered: (value["delivered"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    pickupDeadLines: (value["pickupDeadLines"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    deliveryDeadLines: (value["deliveryDeadLines"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    pendingCustomsClearance: (
      value["pendingCustomsClearance"] as Array<any>
    ).map(CompanyShipmentQuoteToJSON),
    freightDamaged: (value["freightDamaged"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    operatorFlagged: (value["operatorFlagged"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    customerFlagged: (value["customerFlagged"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
    freightShortage: (value["freightShortage"] as Array<any>).map(
      CompanyShipmentQuoteToJSON,
    ),
  };
}
